import { NoDataType } from '@Components/types/NoDataType';

type Output = {
  title: string;
  description: [string, string | undefined];
};

export const getText = (type: NoDataType): Output => {
  if (type === 'my-requests') {
    return {
      title: 'No Data',
      description: ['Please Select Request Type To Continue', undefined],
    };
  }

  if (type === 'approvals') {
    return {
      title: 'No Tasks Assigned',
      description: [
        'You Currently Have No Tasks Assigned To You.',
        'Please Check Back Later Or Contact Your Manager For More Details',
      ],
    };
  }

  if (type === 'empty-materials') {
    return {
      title: 'No Materials Selected',
      description: [
        'You currently have no Materials Selected. Please add materials.',
        undefined,
      ],
    };
  }

  if (type === 'empty-filters') {
    return {
      title: 'No Data',
      description: [
        "Filter can't find any item matching your request",
        undefined,
      ],
    };
  }

  if (type === 'empty-search') {
    return {
      title: 'No Data',
      description: [
        "Search can't find any item matching your request",
        undefined,
      ],
    };
  }

  if (type === 'empty-filters-search') {
    return {
      title: 'No Data',
      description: [
        "Search and filter can't find any item matching your request",
        undefined,
      ],
    };
  }

  return {
    title: '',
    description: ['', undefined],
  };
};

export const getNoDataType = (
  context: NoDataType,
  isSearchApplied: boolean,
  isFiltersApplied: boolean
): NoDataType => {
  if (isSearchApplied && !isFiltersApplied) {
    return 'empty-search';
  }

  if (!isSearchApplied && isFiltersApplied) {
    return 'empty-filters';
  }

  if (isSearchApplied && isFiltersApplied) {
    return 'empty-filters-search';
  }

  return context;
};
